export const getOfferReportTypes = (
  reports: Record<string, Array<string>>,
  offerId: string,
): Array<string> => {
  const reportTypes = reports[offerId];

  if (reportTypes) {
    return reportTypes;
  }

  const matchedOfferId = Object.keys(reports).find((key) => offerId.startsWith(key));

  return matchedOfferId ? reports[matchedOfferId] : [];
};
